import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { getValidationRules } from '../validation/validation'
import SignInComponent from '../components/login/SignInComponent'
import { login } from '../store/actions/session'
import SIGN_IN_RULES from '../validation/validationRules/signIn'
import { SIGN_UP_PATH } from '../constants/routes'

const mapDispatchToProps = {
    login,
}

const mergeProps = (
    stateProps,
    { login }, { history, location, ...state }
) => ({
    ...state,
    onGoToSignUp: () => {
        let path = SIGN_UP_PATH

        history.push(path)
    },
    onSubmit: login,
})

export default withRouter(connect(null, mapDispatchToProps, mergeProps)(reduxForm({
    form: 'login',
    validate: getValidationRules([
        'email',
        'password',
    ], SIGN_IN_RULES),
})(SignInComponent)))



// WEBPACK FOOTER //
// ./src/containers/SignInContainer.js